import React from 'react';

const LoadingSpinner = () => {
    return (
        <div className="flex items-center justify-center p-8">
            <div className="relative">
                <div className="w-12 h-12 border-4 border-yellow-400/20 border-t-yellow-400 rounded-full animate-spin"></div>
                <div className="absolute inset-0 w-12 h-12 border-4 border-transparent border-l-yellow-300 rounded-full animate-pulse"></div>
            </div>
        </div>
    );
};

export default LoadingSpinner;
